
export default {
    name: "CTAButton",
    props: {
        position: {
            type: String,
            default: "left",
            enum: ["left", "right"]
        },
        href: String
    }
};
